import type { IAudience, IExperience } from '~/lib/ContentfulService';

export default function containsMatchingAudience(item: IExperience): boolean {
  const { $matchingAudiences } = useNuxtApp();

  const ids = item.fields.audiences?.map((a: IAudience) => a.sys.id) ?? [];
  for (const id of ids) {
    if ($matchingAudiences.value.includes(id)) {
      return true;
    }
  }
  return false;
}
